import {
  HttpClient,
  HttpClientModule,
  HttpClientXsrfModule,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';

import { AppComponent } from './app.component';
import { AppRoutes } from './app.routing';
import { SharedModule } from './shared/shared.module';
import { CustomHttpInterceptor } from './utilities/CustomHttpInterceptor';
import { UtilitiesService } from './utilities/utilities.service';
import { FilterDataService } from './services/filter-data.service';
import { AlertService } from './services/alert.service';
import { AlertComponent } from './directives/alert/alert.component';
import { environment } from 'src/environments/environment';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CreateRequestService } from './services/create-request.service';
import { TrackRequestService } from './services/track-request.service';
import { PaymentInfoService } from './services/payment-info.service';
import { CheckoutService } from './services/checkout.service';
import { SupportComponent } from './support/support.component';
import { ApplicationInitializationService } from './services/application-initialization.service';
import { AppCmsUrlsInitializationService } from './services/app-cms-urls-initialization.service';

@NgModule({
  declarations: [	
    AppComponent,
    AlertComponent,
      SupportComponent
   ],
  exports: [
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule.forRoot(),
    AppRoutes,
    SharedModule,
    HttpClientModule,
    HttpClientXsrfModule.withOptions({
      cookieName: 'app-Xsrf-Cookie',
      headerName: 'app-Xsrf-Header',
      }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),

    LoadingBarRouterModule,
    LoadingBarHttpClientModule,
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomHttpInterceptor,
      multi: true,
    },
    { provide: 'googleTagManagerId', useValue: 'GTM-TSZ46Z' },
    UtilitiesService,
    FilterDataService,
    AlertService,
    CreateRequestService,
    TrackRequestService,
    PaymentInfoService,
    CheckoutService,
    { 
      provide : APP_INITIALIZER, 
      multi : true, 
      deps : [ApplicationInitializationService], 
      useFactory : (applicationInitializationService : ApplicationInitializationService) => () => applicationInitializationService.initializeApp()
    },
    { 
      provide : APP_INITIALIZER, 
      multi : true, 
      deps : [AppCmsUrlsInitializationService], 
      useFactory :(appCmsUrlsInitializationService : AppCmsUrlsInitializationService) => () => appCmsUrlsInitializationService.appCmsUrlsInitialization(),
    },
  ],

  bootstrap: [AppComponent],
})
export class AppModule { }

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, environment.HOST+'/b2c/cqt-app/assets/i18n/', '.json');
}
